import { useContext } from "react";
import { ArcGISMapMapContext } from "@contexts/arcgis-map-context";

export function useMapSideMenu() {
  const [mapSettings, setMapSettings] = useContext(ArcGISMapMapContext);
  const setSideMenuState = () => setMapSettings({ ...mapSettings, isSideMenuOpen: !mapSettings.isSideMenuOpen });
  return { isSideMenuOpen: mapSettings.isSideMenuOpen, setSideMenuState };
}
